import VehiclePosition from 'common/types/VehiclePosition';

export const REQUEST_VEHICLE_POSITION = 'REQUEST_VEHICLE_POSITION';

export function requestVehiclePosition() {
  return {type: REQUEST_VEHICLE_POSITION};
}

export const RECEIVE_VEHICLE_POSITION = 'RECEIVE_VEHICLE_POSITION';

export function receiveVehiclePosition(agencyId, vehicleId, vehiclePosition) {
  return {type: RECEIVE_VEHICLE_POSITION, agencyId, vehicleId, vehiclePosition};
}

export const SET_VEHICLE_POSITION_TIMEOUT = 'SET_VEHICLE_POSITION_TIMEOUT';

export function setVehiclePositionTimeout(timeout) {
  return {type: SET_VEHICLE_POSITION_TIMEOUT, timeout};
}

export const UNSET_VEHICLE_POSITION_TIMEOUT = 'UNSET_VEHICLE_POSITION_TIMEOUT';

export function unsetVehiclePositionTimeout() {
  return {type: UNSET_VEHICLE_POSITION_TIMEOUT};
}

export function clearVehiclePositionTimeout(timeout) {
  return (dispatch) => {
    clearTimeout(timeout);
    dispatch(unsetVehiclePositionTimeout(timeout));
  };
}

export function fetchVehiclePosition(agencyId, vehicleId) {
  return (dispatch, getState, {api}) => {
    dispatch(requestVehiclePosition());
    return api.fetchVehiclePosition({agencyId, vehicleId, state: getState()})
      .then(response => {
        switch (response.status) {
          case 200:
            return response.json()
              .then((json) => new VehiclePosition(json))
              .then((vehiclePosition) =>
                dispatch(receiveVehiclePosition(agencyId, vehicleId, vehiclePosition))
              );
          case 400:
            return response.json();
          default:
            throw response;
        }
      });
  };
}

export function cancelVehiclePosition() {
  return (dispatch, getState) => {
    const {timeout} = getState().vehiclePosition;
    if (timeout !== null) {
      dispatch(clearVehiclePositionTimeout(timeout));
    }
  };
}

export function pollVehiclePosition(agencyId, vehicleId) {
  return (dispatch) => {
    cancelVehiclePosition();
    dispatch(fetchVehiclePosition(agencyId, vehicleId)).then(() => {
      dispatch(setVehiclePositionTimeout(
        setTimeout(() => {
          dispatch(pollVehiclePosition(agencyId, vehicleId));
        }, 1500),
      ));
    });
  };
}



// WEBPACK FOOTER //
// ./src/ondemand/actions/vehiclePosition.js